import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Wrapper = styled.div<{ selected: boolean }>`
  border: ${({ selected }) =>
    selected ? '1px solid #D47E5B' : '1px solid #D9D9D9'};
  border-radius: 6px;
`;

export const Container = styled.div<{
  selected: boolean;
  disable?: boolean;
  hideIconMobile?: boolean;
}>`
  background: #ffffff;
  border: ${({ selected }) =>
    selected ? '1px solid #D47E5B' : '1px solid transparent'};
  border-radius: 5px;
  padding: 20px 10px 12px;
  min-width: 80px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  ${({ disable }) =>
    disable &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}

  @media screen and (max-width: 950px) {
    padding: ${({ hideIconMobile }) =>
      hideIconMobile ? '12px 10px' : '20px 10px 12px'};
  }
`;

export const Icon = styled(FontAwesomeIcon)<{ hideIconMobile?: boolean }>`
  font-size: 25px;
  color: #4f4f4f;

  @media screen and (max-width: 950px) {
    display: ${({ hideIconMobile }) => (hideIconMobile ? 'none' : 'block')};
  }
`;

export const Text = styled.div<{ hideIconMobile?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: #4f4f4f;
  margin-top: 12px;

  @media screen and (max-width: 950px) {
    margin-top: ${({ hideIconMobile }) => (hideIconMobile ? '0' : '12')}px;
  }
`;
